/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Headline_BeforeInputs */

const en_guestlist_headline_before = /** @type {(inputs: Guestlist_Headline_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage, with the CRM inside.`)
};

/**
* | output |
* | --- |
* | "Backstage, with the CRM inside." |
*
* @param {Guestlist_Headline_BeforeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_headline_before = /** @type {((inputs?: Guestlist_Headline_BeforeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Headline_BeforeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_headline_before(inputs)
});